import { Injectable } from '@angular/core';

import { apiName } from "./data.service";
import { RestService } from "../../core/services/rest.service";

@Injectable()
export class ProjetoApiService {

    constructor(
        private _restService: RestService
    ) { }


    onGetAll(done: any) {
        this._restService.onGetSemSchema(apiName + "/listar-todos", done);
    }

    onGetByTenantName(tenant: string, done: any) {
        this._restService.onGetSemSchema(apiName + '/schema/' + tenant, done);
    }

}


/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/projeto/shared/projeto-api.service.ts
 **/